const ADS_ENABLED = false;

export function areAdsEnabled(): boolean {
  return ADS_ENABLED;
}

export function createAdSlot(slotName: string, className = ""): HTMLElement {
  const slot = document.createElement("aside");
  slot.className = ["ad-slot", className].filter(Boolean).join(" ");
  slot.dataset.adSlot = slotName;
  slot.dataset.adsEnabled = areAdsEnabled() ? "true" : "false";
  slot.setAttribute("aria-label", "Advertisement");

  if (!areAdsEnabled()) {
    slot.hidden = true;
    slot.style.display = "none";
    slot.setAttribute("aria-hidden", "true");
    return slot;
  }

  const label = document.createElement("span");
  label.className = "ad-slot-label";
  label.textContent = "Advertisement";

  slot.append(label);

  return slot;
}